/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import PatchManager from "App/utils/globe/chunk_lod/patch_manager";
import Visitor, {VisitorOrdering} from "App/utils/globe/chunk_lod/visitor";
import TreeNode from "App/utils/globe/chunk_lod/tree/node";
import {ChunkLODNodeState} from "App/utils/globe/chunk_lod/tree/chunk_lod_node";

export default
class VisibilityManager extends Visitor {

    private _patchManager: PatchManager;
    private _visibility: Uint8Array;
    private _needUpdate: boolean;

    constructor(aPatchManager: PatchManager) {
        super();

        this._patchManager = aPatchManager;

        this._visiteeConsumerFunction = this.collectVisibility.bind(this);
        this._ordering = VisitorOrdering.pre;

        this._visibility = null;
        this._needUpdate = true;
    }

    public scheduleUpdate() {
        this._needUpdate = true;
    }

    public needUpdate(): boolean {
        return this._needUpdate;
    }

    public clearVisibility() {
        let info = this._patchManager.getPatchInfo();
        this._visibility = new Uint8Array(TreeNode.getFlattenedTreeSize(info.levels, info.nc));
    }

    public getVisibility(aVisitee: TreeNode) {
        return this._visibility[aVisitee.getAddress().flattenedTreeIndex];
    }

    public testParentsNotVisible(aVisitee: TreeNode) {
        let visible = this._visibility[aVisitee.getAddress().flattenedTreeIndex] === 0;
        
        if (aVisitee.getParent()) {
            visible = visible && this.testParentsNotVisible(aVisitee.getParent());
        }

        return visible;

    }

    public collectVisibility(aVisitee: TreeNode) {
        let address = aVisitee.getAddress();

        // look at children and if they are settled on gpu, then do not render this node
        if (aVisitee.getState() === ChunkLODNodeState.SETTLEDONGPU && !aVisitee.testAllChildrenHasState(ChunkLODNodeState.SETTLEDONGPU)) {
            if (this.testParentsNotVisible(aVisitee)) {
                this._visibility[address.flattenedTreeIndex] = 1;
            }
        }
    }

    public update() {
        if (this._needUpdate) {

            let worker = this._patchManager.getWorker();

            // send visibility vector to main thread and use the vector to decide what nodes will be rendered and what does not
            let message = {
                type: "visibilityUpdate",
                patchInfo: this._patchManager.getPatchInfo(),
                visibility: this._visibility
            };

            this._needUpdate = false;

            worker.schedulePostMessage(message);//, [this._visibility]);
        }
    }
}
